import { useLocation } from 'react-router-dom';
import { Row } from 'antd';
import { useTheme } from 'styled-components';
import { useAppQuery } from 'services/reactQuery/useAppQuery';
import ParentHTTPService from 'services/HTTPService/parent/ParentHTTPService';
import { PageBaseLayout } from 'components/layouts';
import { commonTexts, parentTexts } from 'consts/text';
import { AppFlex, AppFormBanner, AppGoBackButton, AppTitle } from 'components/atoms';
import { EMPTY_VALUE_LABEL } from 'consts/labels/common';
import { PaymentTransferDetails } from 'components/templates';

export const ParentPaymentPage = () => {
    const location = useLocation();

    const theme = useTheme();

    const paymentDataState = location.state as
        | { childId: string; institutionId: string; amount?: number }
        | undefined;
    const childId = paymentDataState?.childId;
    const institutionId = paymentDataState?.institutionId;

    const isPaymentDataAvailable = !!childId && !!institutionId;

    const {
        data: paymentData,
        isInitialLoading: isInitialPaymentDataLoading,
        isRefetching: isRefetchingPaymentData,
        isError: isFetchPaymentDataError,
    } = useAppQuery(
        'PAYMENT_DATA',
        [childId, institutionId],
        () =>
            ParentHTTPService.settlements.getSettlementTransferInformation({
                childId: childId || '',
                institutionId: institutionId || '',
            }),
        {
            enabled: isPaymentDataAvailable,
        },
    );

    const isInstitutionTransferInformationVisible = isPaymentDataAvailable && paymentData;
    const isCateringTransferInformationVisible =
        isPaymentDataAvailable && paymentData?.cateringTransferInformationDto?.transferTitle;

    return (
        <PageBaseLayout
            isDataInitialLoading={isInitialPaymentDataLoading}
            isDataRefetching={isRefetchingPaymentData}
            isError={isFetchPaymentDataError || !isPaymentDataAvailable}
            isEmpty={!paymentData}
            emptyStateData={{ emptyInfo: commonTexts.emptyInfo.noPaymentData }}
        >
            <AppGoBackButton margin={0} marginBottom={16} />
            <AppFormBanner mode="WARNING" text={parentTexts.settlement.paymentWarning} />
            <Row align="bottom" justify="space-between">
                <AppTitle level={4} marginTop={0}>
                    {parentTexts.settlement.paymentDetailsTitle}
                </AppTitle>
            </Row>
            <AppFlex gap={theme.sizes.marginNormal} vertical>
                {isInstitutionTransferInformationVisible && (
                    <PaymentTransferDetails
                        title={`Opłata za dziecko ${paymentData.childSimpleDto.firstName} ${paymentData.childSimpleDto.lastName}`}
                        bankAccountNumber={
                            paymentData.institutionTransferInformationDto.bankAccountNumber
                        }
                        recipientName={paymentData.institutionTransferInformationDto.recipientName}
                    />
                )}
                {isCateringTransferInformationVisible && (
                    <PaymentTransferDetails
                        title={
                            paymentData.cateringTransferInformationDto?.transferTitle ||
                            EMPTY_VALUE_LABEL
                        }
                        bankAccountNumber={
                            paymentData.cateringTransferInformationDto?.bankAccountNumber ||
                            EMPTY_VALUE_LABEL
                        }
                        recipientName={
                            paymentData.cateringTransferInformationDto?.recipientName ||
                            EMPTY_VALUE_LABEL
                        }
                    />
                )}
            </AppFlex>
        </PageBaseLayout>
    );
};
